export default {"src":"/_next/static/media/RU.dbd87508.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};